module.exports = __webpack_public_path__ + "static/media/bg7.013b0488.jpg";